module.exports = __webpack_public_path__ + "img/pairing_logo@2x.ca44246f.png";